import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'La masă',
      [RoomServiceLocationType.TableService]: 'La masă',
      both: 'La masă',
    },
    [ORDER_METHODS.PICKUP]: 'Ridicare',
    [ORDER_METHODS.DELIVERY]: 'Livrare',
  },
};
